import { mainHost } from "./Links";
import Axios from "axios";
import TokenService from "../../services/jwt-token/jwt-token";

export function getData(link, params, onSuccess, onFail) {
	Axios.get(mainHost + link, {
		params,
		headers: {
			"content-type": "application/json",
			// authorization: localStorage.getItem("token"),
			authorization: TokenService.getAccessToken(),
		},
	})
		// .then((res) => res)
		.then((res) => {
			onSuccess(res);
		})
		.catch((err) => {
			onFail(err);
		});
}

export function postData(
	link,
	data = null,
	contentType = "multipart/form-data",
	onSuccess,
	onFail
) {
	Axios.post(mainHost + link, data, {
		headers: {
			"content-type": contentType,
		},
	})
		// .then((res) => res)
		.then((res) => {
			onSuccess(res);
		})
		.catch((err) => {
			onFail(err);
		});
}

export function patchData(
	link,
	data,
	params,
	contentType = "multipart/form-data",
	onSuccess,
	onFail
) {
	Axios.patch(mainHost + link, data, {
		params,
		headers: { "content-type": contentType },
	})
		// .then((res) => res)
		.then((res) => {
			onSuccess(res);
		})
		.catch((err) => {
			onFail(err);
		});
}

export function deleteData(link, params, onSuccess, onFail) {
	Axios.delete(mainHost + link, {
		params,
		headers: { "content-type": "application/json" },
	})
		// .then((res) => res)
		.then((res) => {
			onSuccess(res);
		})
		.catch((err) => {
			onFail(err);
		});
}
